export enum PayinFlowMode {
  Requisite = 'requisite',
  PaymentForm = 'payment_form',
  OrderWithForm = 'order_with_form',
}
